import { render, staticRenderFns } from "./updateRemarkDialog.vue?vue&type=template&id=74620634&"
import script from "./updateRemarkDialog.vue?vue&type=script&lang=js&"
export * from "./updateRemarkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74620634')) {
      api.createRecord('74620634', component.options)
    } else {
      api.reload('74620634', component.options)
    }
    module.hot.accept("./updateRemarkDialog.vue?vue&type=template&id=74620634&", function () {
      api.rerender('74620634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/updateRemarkDialog.vue"
export default component.exports